'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Badge = require('./components/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# MarketingCTA
A marketing CTA section with CTAs & Advertisements.
 */
var MarketingCTA = function MarketingCTA(_ref) {
  var _ref$contentItems = _ref.contentItems,
      contentItems = _ref$contentItems === undefined ? [] : _ref$contentItems,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === undefined ? false : _ref$vertical;
  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $vertical: vertical
    },
    _react2.default.createElement(_Badge2.default, {
      $visible: vertical
    }),
    contentItems
  );
};

MarketingCTA.propTypes = {
  /** The content items to display inside the container. */
  contentItems: _propTypes2.default.arrayOf(_propTypes2.default.node),
  /** Boolean setting if the container is vertical across all breakpoints. */
  vertical: _propTypes2.default.bool
};

MarketingCTA.displayName = 'MarketingCTA';

exports.default = MarketingCTA;
MarketingCTA.__docgenInfo = {
  'description': '# MarketingCTA\r\nA marketing CTA section with CTAs & Advertisements.',
  'methods': [],
  'displayName': 'MarketingCTA',
  'props': {
    'contentItems': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'node'
        }
      },
      'required': false,
      'description': 'The content items to display inside the container.'
    },
    'vertical': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Boolean setting if the container is vertical across all breakpoints.'
    }
  }
};